import { GregorioGlyphType } from '../enums/GregorioGlyphType';
import { GregorioLiquescentia } from '../enums/GregorioLiquescentia';
import { GregorioNoteElement } from './GregorioNoteElement';



export class GregorioNoteGlyph {
  get first_note(): GregorioNoteElement | undefined {
    if (!this.notes.length) {
      return undefined;
    }
    return this.notes[0];
  }

  get last_note(): GregorioNoteElement | undefined {
    if (!this.notes.length) {
      return undefined;
    }
    return this.notes[this.notes.length - 1];
  }

  get allNotes(): GregorioNoteElement[] {
    return this._notes;
  }

  get notes(): GregorioNoteElement[] {
    if (this._startFrom) {
      return this._notes.slice(this._startFrom);
    }
    return this._notes;
  }

  set notes(notes: GregorioNoteElement[]) {
    this._notes = notes;
  }

  _notes: GregorioNoteElement[] = [];
  _startFrom: number | null = null;

  set startFrom(startFrom: number | null) {
    this._startFrom = startFrom;
  }

  fuse_to_next_glyph!: number;
  glyph_type!: GregorioGlyphType;
  liquescentia!: GregorioLiquescentia;
  is_cavum!: boolean;
}
